module.exports = __webpack_public_path__ + "officialStatic/img/index-product-guangwang.c4d6931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-product-guangwang.png
// module id = dlaf
// module chunks = 0